import React from 'react'
import { motion } from 'framer-motion'

const variants = {
  fadeIn: {
    easing: 'easeOut',
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  slideUp: {
    easing: 'easeOut',
    from: { opacity: 0, y: '100%' },
    to: { opacity: 1, y: 0 },
  },
  slideOver: {
    easing: 'easeOut',
    from: { x: '-10%', opacity: 0 },
    to: { x: 0, opacity: 1 },
  },
}

const speeds = {
  slow: 2,
  medium: 1,
  fast: 0.5,
}

interface Variant {
  easing: string
  from: string
  to: string
}

export interface Props {
  animateOnce?: boolean
  as?: React.ElementType
  children: React.ReactNode
  className?: string
  duration?: keyof typeof speeds | number
  variant: keyof typeof variants | Variant
}

export const AnimateIn: React.FC<Props> = ({
  animateOnce = true,
  as: Tag = 'div',
  children,
  className,
  duration = 'medium',
  variant,
}) => {
  const { easing, from, to } = typeof variant === 'string' ? variants[variant] : variant
  const durationSeconds = typeof duration === 'string' ? speeds[duration] : duration

  const MotionComponent = motion(Tag)

  return (
    <MotionComponent
      initial={from}
      whileInView={to}
      viewport={{ once: animateOnce }}
      transition={{ ease: easing, duration: durationSeconds }}
      className={className}
    >
      {children}
    </MotionComponent>
  )
}

export default AnimateIn
